import {Component, OnInit} from '@angular/core';
import {Router, RouterEvent} from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {


  selectedPath = '/home';
  menu = [{
    url: '/dashboard',
    icon: 'home-outline',
    title: 'Inicio'
  },
    {
      url: '/aviso-privacidad',
      icon: 'headset-outline',
      title: 'Enrolar'
    },
    {
      url: '/bandeja-contratos',
      icon: 'card-outline',
      title: 'Firma Contrato'
    }];

  constructor(private router: Router) {


    this.router.events.subscribe((event: RouterEvent) => {

      if (event.url !== undefined) {
        this.selectedPath = event.url;
      } else if (this.selectedPath === '/home/contactanos') {

        this.selectedPath = '/home/quienes-somos';
      }

    });
  }

  ngOnInit() {
  }

  async salir() {


  }

}
